import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";
import store, {persistor} from "Store";
import {BrowserRouter} from "react-router-dom";
import history from './history'
import Layout from "Components/layout";
import React from "react";
import useIframeSize from "./Components/ui/hooks/useIframeSize";


const AppProvider = () => {
  useIframeSize();

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter history={history}>
          <Layout/>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  )
}

export default AppProvider